import request from '@/utils/request'
import { AxiosPromise } from 'axios'
export function getHoverInfo(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design/common/hover',
    method: 'get',
    params: data,
  })
}
export function uploadfiles(data: any) {
  return request({
    url: '/api/design/uploads',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data,
  })
}
export function saveTemplate(data: any) {
  return request({
    url: '/api/design/template/save',
    method: 'post',
    data,
  })
}